/**
 * Custom stacked slider used in photo-carousel block.
 */
window.onload = function() {

	const validate_index = ( index, total, move ) => {
		switch( move ) {
			case 'next':
				if ( index >= total ) {
					index = 0;
				} else {
					index = index + 1;
				}
				break;
			case 'prev':
				if ( 0 === index ) {
					index = total;
				} else {
					index = index - 1;
				}
				break;
		}

		return index;
	}

	const move_slide = ( $items, index, $parent ) => {
		$replace_child = false;
		for ( var $i=0; $i <= $items.length - 1; $i++ ) {
			if ( $items[$i].classList.contains('active') ) {
				$replace_child = $items[$i];
				$items[$i].classList.remove('active');
			}
		}

		$items[index].classList.add('active');
		$parent.replaceChild( $items[index], $replace_child );
		$parent.appendChild( $replace_child );
	}

	const init_carousel = () => {
		let $slider_block = document.querySelectorAll('.block--photo-carousel.display-style--stack');

		for ( var $i=0; $i <= $slider_block.length - 1; $i++ ) {

			let index = 0;
			let $slider = $slider_block[$i];
			let $parent = $slider.getElementsByClassName('photo-carousel--images')[0];
			let $items  = $slider.querySelectorAll('.photo-carousel__item');
			let total   = $items.length - 1;
			let $slide  = $items[0];

			setTimeout(function(){
				$slide.classList.add('active');
				var height = $slide.getBoundingClientRect().height + ( total * 2 );
				$parent.style.height = height + 'px';
				$slider.classList.add('active');
			}, 1000);


			if ( total > 1 ) {

				let $arrows = $slider.getElementsByClassName('block--photo-carousel--navigation--arrows')[0];

				$arrows.innerHTML = '<button class="carousel-arrow carousel-arrow--prev"><span class="screen-reader-text">Previous Slide</span></button> <button class="carousel-arrow carousel-arrow--next"><span class="screen-reader-text">Next Slide</span></button>';

				$arrows.getElementsByClassName('carousel-arrow--prev')[0].addEventListener( 'click', (e) => {
					e.preventDefault();
					index = validate_index( index, total, 'prev' );
					move_slide( $items, index, $parent );
				});

				$arrows.getElementsByClassName('carousel-arrow--next')[0].addEventListener( 'click', (e) => {
					e.preventDefault();
					index = validate_index( index, total, 'next' );
					move_slide( $items, index, $parent );
				});
			}
		}
	}

	init_carousel();

	window.addEventListener( 'resize', () => {
		init_carousel();
	} );
}
